import React, {memo} from "react";
import styles from './FJStockModalFooterView.module.less';
import FJButton from 'fj-components/FJButton'
import FJLocalStore from "../../../../store/FJLocalStore";
import AddIcon from '../../../../icon/stock-add.svg';
import AddSuccessIcon from '../../../../icon/add-success.svg';
import classNames from 'classnames';

function FJStockModalFooterView(props){
	let { photoStyle, onCancel, onSubmit, isAddToLibrary } = props;
	return (
		<div className={classNames(styles.footer_box, {[styles.photo]: photoStyle})}>
			<FJButton text={FJLocalStore._('cancel')}
			          className={styles.cancel_btn}
			          textClass={styles.cancel_text}
			          onClick={onCancel}
			/>
			<FJButton icon={isAddToLibrary ? AddSuccessIcon : AddIcon}
			          text={FJLocalStore._(isAddToLibrary ? 'remove-lib' : 'add-lib')}
			          className={styles.add_btn}
			          textClass={styles.add_text}
			          onClick={onSubmit}
			/>
		</div>
	)
}

export default memo(FJStockModalFooterView);